module.exports = accountingDashboard;